<nb-card>
  <div class="details">
    <div class="title text-hint">
      <nb-icon [icon]="icon" [status]="type"></nb-icon>
      {{ title }}
    </div>
    <h5 class="text-{{ type }}">{{ value | number }}</h5>
    <div *ngIf="quantity" class="status paragraph-2">
      <h6>
        {{ "common.quantityShort" | translate }}:
        <strong>{{ quantity | number }}</strong>
      </h6>
    </div>
  </div>
</nb-card>
